import React,{useEffect, useRef} from 'react'
import { useState } from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';
import { Print } from '@mui/icons-material';
import inventoryTransferServices from '../inventoryTransferServices';
import MonthlyDateSelect from '../../../../../../components/AppInput/MonthlyDateSelect';

function InventoryTransferVoucherList() {
    const gridRef = useRef();
    const {companyDD, userDD, companyLocationDD,  productDD, vendorDD,getDDDataById} = useAppData();
    const [transferVoucherList,setTransferVoucherList] = useState(null);
    const [filter,setFilter] = useState(null);

    const getInventoryTransferVoucherList = () =>{
        inventoryTransferServices.getList(filter).then(res=>{
        setTransferVoucherList(res.data);
        }).catch(error=>{
        }).finally(()=>{
        })
    }
    

    const [defaultColDef] = useState({
        floatingFilter: true,
        filterParams: {
        buttons: ['apply'],
        },
        resizable: true,
        width:120,
        filter:true,
        sortable: true,
        cellStyle: { 'textTransform': 'uppercase' },
    });


    const [columnDefs,setColumnDef] = useState();
        const prepairColumnDef = () => {
        let _columnDefs = [
            {field:"id",headerName: "ID"},

            {headerName: "Company", width:200,
            valueGetter:params=>{
                let _data = getDDDataById(companyDD,params.data.companyId);
                return _data.label;
            }
            },

            {headerName: "Source Location", width:200,
            valueGetter:params=>{
                let _data = getDDDataById(companyLocationDD,params.data.fromLocationId);
                return _data.label;
            }
            },

            {headerName: "Destination Location", width:200,
                valueGetter:params=>{
                    let _data = getDDDataById(companyLocationDD,params.data.toLocationId);
                    return _data.label;
                }
            },

            {headerName: "Created By", width:200,
                valueGetter:params=> getDDDataById(userDD,params.data.userId)?.label
            },

            {field:"transferDate",headerName: "T. Date", width:200,},
            
            
            {field:"updated_at",headerName: "Last Updated", width:200,},
            
        ];
        setColumnDef(_columnDefs);
    }

    const onBtnExport = () => {
        gridRef.current.api.exportDataAsCsv("data.csv");
    };

    useEffect(()=>{    
        prepairColumnDef();
    },[]);

    useEffect(()=>{
      getInventoryTransferVoucherList()
    },[filter])
  return (
    
    
          <div className='row'>
            <div className='col-md-6'><h4>Transfer Voucher List</h4></div>
            <div className='col-md-6'>
                <MonthlyDateSelect filter={filter} setFilter={setFilter} />
                <button className='btn btn-outline-primary float-end mb-2' onClick={onBtnExport}><Print/> Export</button>
            </div>
            <div className="ag-theme-alpine" style={{height: 700}}>
                <AgGridReact
                    ref={gridRef}
                    rowData={transferVoucherList}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={true}
                    onGridReady={getInventoryTransferVoucherList}
                />
            </div>
          </div>
        
    
    )
}

export default InventoryTransferVoucherList